export default __webpack_public_path__ + "static/media/sc_ac.2e987df9.png";